/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
import {
  call,
  race,
  take,
  takeEvery,
  fork,
  debounce,
  delay,
  select,
  getContext,
} from "typed-redux-saga";
import { getType } from "typesafe-actions";
import {
  allStaticData,
  liveRefreshWatcher,
  getJobDetailsByIdSaga,
  applyOffsetAdjustmentsSaga,
} from "./saga";
import { rootActions, RootState } from "../";
import { selectIsAuthenticated } from "../selectors";
import { CMSClientType } from "@/cms-api";

export function* processActionsRootSaga() {
  yield* fork(processActionsRefreshLoop);
  yield* takeEvery(
    getType(rootActions.processUpdates.detailsTableInnerTableRowClicked),
    getJobDetailsByIdSaga
  );
  yield* takeEvery(
    getType(rootActions.processUpdates.applyOffsetAdjustments),
    applyOffsetAdjustmentsSaga
  );
  yield* debounce(
    500,
    getType(rootActions.processUpdates.processUpdatesTableTypeChanged),
    updateProcessUpdatesTabPreferenceSaga
  );
}

function* processActionsRefreshLoop() {
  while (true) {
    yield* call(allStaticData);
    yield* race({
      liveRefreshWatcher: call(liveRefreshWatcher),
      cancel: take([getType(rootActions.session.startEndUpdated)]),
    });
  }
}

function* updateProcessUpdatesTabPreferenceSaga() {
  try {
    yield* delay(50);

    const isAuthenticated = yield* select(selectIsAuthenticated);
    if (!isAuthenticated) return;

    const client = yield* getContext<CMSClientType>("client");
    const preferences = yield* select(
      (state: RootState) => state.global.preferences
    );
    const processUpdatesTab = yield* select(
      (state: RootState) => state.processUpdates.processUpdatesTableTypeSelected
    );

    const response = yield* call(
      (updatedPreferences) =>
        client.preferences.updatePages(updatedPreferences).promise,
      {
        ...preferences,
        processUpdatesTab,
      }
    );
    response;
  } catch (e) {
    console.error("Failed to save process updates tab to database:", e);
  }
}
